// src/components/MailIcon.jsx
import React from 'react';
import PropTypes from 'prop-types';

/**
 * MailIcon renders a mail/envelope SVG icon.
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes to apply
 * @param {number|string} props.width - Width of the SVG
 * @param {number|string} props.height - Height of the SVG
 * @param {string} props.color - Fill color for the icon
 */
const MailIcon = ({ className = '', width = 24, height = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    className={className}
    fill={color}
  >
    <path d="M4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20zm8-7L4 8v10h16V8zm0-2l8-5H4zM4 8V6v12z" />
  </svg>
);

MailIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string
};

export default MailIcon;